<template lang="pug">
	.actions-remove-website-css(v-if="showed")
		.card
			.card-header
				i.fa.fa-trash
				span Delete Website CSS
			.card-body.collapse.show
				.form-horizontal
					.form-group
						.confirmation(v-if="state === 'confirmation'")
							label.col-form-label {{'Are you sure you want to delete JSON and CSS for ' + domain + '?'}}
						.fetching(v-else-if="state === 'fetching'")
							.icon.fa.fa-spinner.fa-spin
						.error(v-else-if="state === 'error'")
							span {{error}}
					.form-actions
						button.btn.btn-danger(type="submit" v-on:click="deleteCss()") Delete JSON and CSS
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

import Screen 				from './../../mixins/screen';

import { Settings } 		from './../../services/Settings';

export default {
	name: "ActionsRemoveWebsiteCss",
	mixins: [Screen],
	screen: {
		updateOn: [],
		showed: false,
		events: {
			'Delete Css Domain Result': function (error, domain) {
				if (error) {
					this.state = 'error';
					this.error = error;
					return;
				}

				Broadcast.call('Remove Website Css', [domain]);

				this.hide();
			}
		}
	},
	data() {

		this.Settings = Settings;

		return {
			state: 'confirmation',
			error: '',
			domain: ''
		};

	},
	methods: {
		collectData(action, domain) {
			this.state = 'confirmation';
			this.error = '';
			this.domain = domain;
		},
		deleteCss() {

			Server.sendToSocket({
				DeleteCssForDomain: {
					domain: this.domain
				}
			});

			this.state = 'fetching';

		}
	}
}
</script>


<style lang="sass">

.actions-remove-website-css
	position: absolute
	z-index: 2000
	left: 0
	top: 0
	right: 0
	bottom: 0
	background-color: rgba(0, 0, 0, 0.6)

	.card
		width: 500px
		position: absolute
		left: 0
		right: 0
		top: 0
		bottom: 0
		margin: auto
		display: flex
		height: 180px
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

		.form-group > div
			height: 40px

		.btn-ghost-dark
			float: right
			color: #fff

</style>

